import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { AppInitializeService } from './common/services/appInitialize.service';
import { HttpInterceptor } from './common/services/httpInterceptor.service';
import { ROUTES } from './app.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { PopupComponent } from './common/utilities/popup/popup.component';
import { SharedModule } from './common/utilities/shared/shared.module';
import { CookieService } from 'ngx-cookie-service';
import { LoginComponent } from './login/login.component';
import { Ng2CompleterModule } from 'ng2-completer';
import { FormsModule } from '@angular/forms';
import { HelperlinkComponent } from './helperlink/helperlink.component';
import { PricingConsentComponent } from './pricingConsent/pricingConsent.component';
import { VerifyOfficialEmailComponent } from './verifyOfficialEmail/verifyOfficialEmail.component';
import { ReloadDirective } from './Directives/reload.directive';
import { CircleProgressbarComponent } from './circleProgressBar/circleProgressBar.component';
import { ErrorPageComponent } from './errorPage/errorpage.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BitlyComponent } from './bitlyComponent/bitlyComponent.component';
import { EsignComponent } from './esign/esign.component';
import { EsignOtpComponent } from './esign-otp/esign-otp.component';
import { EsignThankyouComponent } from './esign-thankyou/esign-thankyou.component';
import { EpbitlyComponent } from './epbitly/epbitly.component';
import { EpbitlyService } from './epbitly/epbitly.service';
import { UserDetailsComponent } from './user-details/user-details.component';
import { InprogressComponent } from './inprogress/inprogress.component';
export function init_app(appInitService: AppInitializeService) {
  return () => appInitService.initializeApp();
}
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    PopupComponent,
    LoginComponent,
    HelperlinkComponent,
    CircleProgressbarComponent,
    PricingConsentComponent,
    VerifyOfficialEmailComponent,
    ReloadDirective,
    ErrorPageComponent,
    BitlyComponent,
    EsignComponent,
    EsignOtpComponent,
    EsignThankyouComponent,
    EpbitlyComponent,
    UserDetailsComponent,
    InprogressComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule,
    Ng2CompleterModule,
    FormsModule,
    RouterModule.forRoot(ROUTES),
    SharedModule.forRoot(),
    CarouselModule.forRoot()
  ],
  providers: [
    AppInitializeService,
    CookieService,
    EpbitlyService
    // HttpInterceptor,
    // {provide: APP_INITIALIZER, useFactory: init_app, deps: [AppInitializeService], multi: true }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
